import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const Logo = (props) => {
  const { src } = props;
  const { t } = useTranslation();

  return (
    <div className="logo">
      <img src={src} alt={t('header.logoAlt')} />
    </div>
  );
};

Logo.propTypes = {
  src: PropTypes.string.isRequired,
};

export default Logo;
